export class Utils {
  public static readonly seedLength = 36;

  public static readonly duration = 200;

  public static readonly second = 1000;

  public static limit = 100;

  public static seed(length: number = this.seedLength): string {
    let str = "";

    const letters = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";

    const dictionary = `${letters}${letters.toUpperCase()}${numbers}`;
    for (let i = 0; i < length; i++) {
      str += dictionary.charAt(Math.floor(Math.random() * dictionary.length));
    }

    return str;
  }
}
